<template>
  <footer class="footer">
    <div class="footer-content">
      <!-- <div class="footer-section">
        <h3>关于我们</h3>
        <p>科研种子图片库是一个免费的图片分享平台，提供海量高质量图片素材。</p>
      </div> -->

      <div class="footer-section">
        <ul>
          <li><router-link to="/about">关于我们</router-link></li>
          <li><router-link to="/terms">联系客服</router-link></li>
          <li><router-link to="/privacy">下载说明</router-link></li>
        </ul>
      </div>

      <div class="footer-section">
        <ul>
          <li><router-link to="/about">上传必读</router-link></li>
          <li><router-link to="/terms">提现须知</router-link></li>
          <li><router-link to="/privacy">网站协议</router-link></li>
        </ul>
      </div>

      <div class="footer-section">
        <!-- <h3>快速链接</h3> -->
        <ul>
          <li><router-link to="/about">支付协议</router-link></li>
          <li><router-link to="/terms">版权声明</router-link></li>
          <li><router-link to="/privacy">帮助中心</router-link></li>
        </ul>
      </div>

      <div class="footer-section">
        <h3>客服邮箱</h3>
        <p>479129380@qq.com(工作日9:00-22:00)</p>
      </div>

      <div class="footer-section">
        <!-- <h3>联系我们</h3> -->
        <div class="qrcode-container">
          <div class="qrcode-item">
            <img src="@/assets/wechat_qrcode.png" alt="客服微信1" />
          </div>
          <div class="qrcode-item">
            <img src="@/assets/qq_qrcode.png" alt="客服微信2" />
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <p>© 2025 科研种子. All Rights Reserved.</p>
        <p>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">
            浙ICP备12345678号-1
          </a>
          <span class="divider">|</span>
          <a href="http://www.beian.gov.cn/" target="_blank" rel="noopener">
            浙公网安备 33010002000123号
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: #f8f9fa;
  padding-top: 40px;
  margin-top: 60px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 0.5fr 0.5fr 0.5fr 1fr 1fr;
  gap: 40px;
  /* margin-bottom: 40px; */
}

.footer-section h3 {
  color: #333;
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: 600;
}

.footer-section p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-section ul li {
  margin-bottom: 10px;
}

.footer-section ul li a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-section ul li a:hover {
  color: #4CAF50;
}

.footer-bottom {
  border-top: 1px solid #eee;
  padding: 20px 0;
  background-color: #fff;
}

.footer-bottom-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
}

.footer-bottom p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.footer-bottom a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-bottom a:hover {
  color: #4CAF50;
}

.divider {
  margin: 0 10px;
  color: #ddd;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .footer-bottom-content {
    flex-direction: column;
    gap: 10px;
  }
}

.qrcode-container {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.qrcode-item {
  text-align: center;
}

.qrcode-item img {
  width: 120px;
  height: 120px;
  /* margin-bottom: 8px; */
}

.qrcode-item p {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.customer-service-email {
  margin-top: 15px;
  color: #666;
  font-size: 14px;
}
</style>
